import { Trans, t } from '@lingui/macro';
import React, { FC, useState } from 'react';
import { Helmet } from 'react-helmet-async';

import config from 'config/config';
import { Button } from 'uikit/Button';
import analytics from 'utils/analytics/analytics';
import routes from 'utils/routeTranslator';

import './Referral.scss';
import ReferralForm from './ReferralForm';

const Referral: FC = () => {
  const [isFormOpen, setIsFormOpen] = useState<boolean>(false);

  const openForm = () => {
    setIsFormOpen(true);
    analytics.trackEvent('referral_start');
  };

  const closeForm = () => setIsFormOpen(false);

  const siteTitle = t`Współpracuj z Fixly.pl`;
  // eslint-disable-next-line max-len
  const siteDescription = t`Jesteś blogerem lub vlogerem? Prowadzisz serwis internetowy o tematyce budowlano-remontowej lub szukasz dodatkowego źródła zarobku? Zostań partnerem Fixly!`;

  return (
    <div className="referral">
      <Helmet>
        <title>{siteTitle}</title>
        <meta property="og:description" content={siteDescription} />
        <meta name="msapplication-tooltip" content={siteDescription} />
        <meta name="description" content={siteDescription} />
        <link rel="canonical" href={config.SITE_URL + routes.get('front::referral')} />
      </Helmet>

      <h1 className="referral__title">
        <Trans>Współpraca</Trans>
      </h1>
      <p className="referral__subtitle">
        <Trans>
          Chcesz nawiązać z nami współpracę? Szukasz dodatkowego źródła zarobku? Masz pomysł na projekt, który
          moglibyśmy wspólnie zrealizować? Zostań partnerem Fixly!
        </Trans>
      </p>

      <section className="referral__section">
        <h2 className="referral__sectionTitle">
          <Trans>Skontaktuj się z nami, jeżeli:</Trans>
        </h2>
        <ul className="referral__sectionList">
          <li className="referral__sectionListItem">
            <Trans>jesteś blogerem lub vlogerem;</Trans>
          </li>
          <li className="referral__sectionListItem">
            <Trans>
              prowadzisz serwis internetowy o tematyce budowlano-remontowej, architektonicznej, wnętrzarskiej, meblowej
              lub związanej z innymi usługami dostępnymi na Fixly;
            </Trans>
          </li>
          <li className="referral__sectionListItem">
            <Trans>jesteś wykonawcem i chcesz dzielić się swoją wiedzą;</Trans>
          </li>
          <li className="referral__sectionListItem">
            <Trans>masz ciekawy projekt lub inicjatywę i chcesz nas w to zaangażować.</Trans>
          </li>
        </ul>
      </section>
      <section className="referral__section">
        <h2 className="referral__sectionTitle">
          <Trans>Proponowane formy współpracy:</Trans>
        </h2>
        <ul className="referral__sectionList">
          <li className="referral__sectionListItem">
            <Trans>materiał przedstawiający Fixly na Twojej stronie lub kanale (video bądź tekst);</Trans>
          </li>
          <li className="referral__sectionListItem">
            <Trans>wpis sponsorowany z odnośnikiem do strony;</Trans>
          </li>
          <li className="referral__sectionListItem">
            <Trans>artykuł ekspercki lub poradnikowy na blogu Fixly;</Trans>
          </li>
          <li className="referral__sectionListItem">
            <Trans>wspólna akcja promocyjna lub marketingowa.</Trans>
          </li>
        </ul>
      </section>
      <p className="referral__text">
        <Trans>
          Kwestie związane z wynagrodzeniem ustalamy indywidualnie i dopasowujemy do formy oraz zakresu współpracy.
        </Trans>
      </p>
      <div className="referral__buttonWrap">
        <Button kind="cta" width="wide" onClick={openForm}>
          <Trans>Napisz do nas</Trans>
        </Button>
      </div>

      <div className="referral__form">
        <ReferralForm isFormOpen={isFormOpen} onClose={closeForm} />
      </div>
    </div>
  );
};

export default Referral;
